import { useBlockProps } from "@wordpress/block-editor";
import apiFetch from "@wordpress/api-fetch";
import { useState, useEffect } from "@wordpress/element";

const Edit = (props) => {
	const blockProps = useBlockProps();
	const [post, setPosts] = useState([]);

	const fetchPost = async () => {
		let path = "/wp/v2/testimonios";
		const newTest = await apiFetch({ path });
		setPosts(newTest);
	};

	useEffect(() => {
		fetchPost();
	}, []);

	try {
		const swiperTestimony = new SwiperClass(".swiperTestimonios", {
			spaceBetween: 16,
			scrollbar: {
				el: ".scroll-testimony",
				draggable: true,
			},
			navigation: {
				nextEl: ".testimony-button-next",
				prevEl: ".testimony-button-prev",
			},
			breakpoints: {
				// when window width is >= 320px
				320: {
					// slidesPerGroup: 1,
					slidesPerView: "auto",
					slidesPerGroupAuto: true,
				},
				470: {
					slidesPerGroupAuto: true,
					// slidesPerGroup: 2,
					slidesPerView: 2,
				},
				950: {
					slidesPerGroupAuto: true,
					// slidesPerGroup: 2,
					slidesPerView: 3,
				},
				1280: {
					slidesPerGroupAuto: true,
					// slidesPerGroup: 2,
					slidesPerView: 4,
				},
			},
		});
	} catch (error) {
		console.error(error);
	}

	return (
		<>
			{post.length > 0 && (
				<section {...blockProps} className="relative px-4 py-10 overflow-hidden md:gap-y-0 md:grid md:grid-cols-12 md:gap-4 bg-cgWhite-ContrastTrue">
					<div className="relative mb-8 md:col-span-10 md:col-start-2">
						<h2 className="py-4 md:font-bold">Testimonios</h2>
						<div className="swiper-scrollbar scroll-testimony !z-30"></div>
					</div>
					<div className="md:col-span-10 md:col-start-2">
						<div className="mt-1 !overflow-visible swiper swiperTestimonios">
							<div className="flex justify-between w-full">
								<div className="testimony-button-prev cg-button-prev">
									<iconify-icon
										className="text-5xl text-cgBlue"
										icon="iconamoon:arrow-left-2-light"
									></iconify-icon>
								</div>
								<div className="testimony-button-next cg-button-prev">
									<iconify-icon
										className="text-5xl text-cgBlue"
										icon="iconamoon:arrow-right-2-light"
									></iconify-icon>
								</div>
							</div>
							<div className="swiper-wrapper">
								{post.map((testimonio, index) => (
									<div className="swiper-slide" key={index}>
										<div className="p-6 bg-cgWhite drop-shadow">
											<p className="" dangerouslySetInnerHTML={{ __html: testimonio.content.rendered }}></p>
											<p className="pt-4 text-2xl font-OldStandard" dangerouslySetInnerHTML={{ __html: testimonio.title.rendered }}>
											</p>
										</div>
									</div>
								))}
							</div>
						</div>
					</div>
				</section>
			)}
		</>
	);
};

export default Edit;
